import { useCallback, useState } from "react";
import { Check, Copy } from "lucide-react";
import { cn } from "@/lib/utils";
import { toast } from "sonner";

interface CopyWrapperProps {
  copyText: string;
  label: string;
  className?: string;
  children: React.ReactNode;
}

export function CopyWrapper({ copyText, label, className, children }: CopyWrapperProps) {
  const [copied, setCopied] = useState(false);

  const handleCopy = useCallback(async () => {
    try {
      await navigator.clipboard.writeText(copyText);
      setCopied(true);
      toast.success(`${label} copied`);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      toast.error("Failed to copy");
    }
  }, [copyText, label]);

  return (
    <div className={cn("group/copy relative", className)}>
      {children}
      <button
        className="absolute right-2 top-2 flex h-7 w-7 items-center justify-center rounded-md border border-border bg-background/80 opacity-0 shadow-sm backdrop-blur-sm transition-opacity hover:bg-accent group-hover/copy:opacity-100"
        onClick={handleCopy}
        title={label}
        aria-label={label}
        type="button"
      >
        {copied ? (
          <Check className="h-3.5 w-3.5 text-green-500" />
        ) : (
          <Copy className="h-3.5 w-3.5 text-muted-foreground" />
        )}
      </button>
    </div>
  );
}
